import React from "react"
import {
    ConversationStatus,
    ConversationStatuses
} from "../../state/conversation/ConversationStatuses"
import Icon from "../../common/icon/icon.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import { getLabelType, getStatusLabel } from "./ConversationStatusComponent"

type OwnProps = {
    status: ConversationStatus
    isLoading: boolean
    onChange: (newStatus: ConversationStatus) => void,
}

const ConversationStatusButtonSelectorComponent = (props: OwnProps) => {
    return (
        <div className="dropup mr-2 mb-2" role="group">
            <button type="button"
                className={`btn py-2 btn-outline-${getLabelType(props.status)}`}
                data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false"
                disabled={props.isLoading}>
                {!props.isLoading ? <span>
                    <Icon value={"edit"} className={"mr-1"}/>
                    {getStatusLabel(props.status)}
                    <Icon value={"caret-up"} className={"ml-1"}/>
                </span> : <LoadingSpinner
                    height={15}
                    width={3}
                    className="px-5"
                />}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnOrderStatus">
                {ConversationStatuses.map(s => {
                    return <a
                        key={s} className="dropdown-item" href="#" onClick={(e) => {
                            e.preventDefault()
                            props.onChange(s as ConversationStatus)
                        }}>
                        <span className={"badge badge-" + getLabelType(s as ConversationStatus)}>
                            {getStatusLabel(s as ConversationStatus)}
                        </span>
                    </a>
                })}
            </div>
        </div>
    )
}

export default ConversationStatusButtonSelectorComponent


// WEBPACK FOOTER //
// ./src/inbox/components/ConversationStatusButtonSelectorComponent.tsx